export default __webpack_public_path__ + "static/media/clickicon.59bd6a0a.svg";